$(document).on('click', '.slide-title', function () {
  $(this).next('.slide-content').stop(true, true).slideToggle(200);
});

$(document).ready(function() {
    designRender();

    window.addEventListener('__bundle_changed', function(e){
        designRender();
    }, false);

    setupShapeFilter();
});

function setupShapeFilter() {
  // when a shape button is clicked
  $('.shape').on('click', function () {
    const $this = $(this);
    const selectedShape = $this.text().trim();

    // toggle active class
    if ($this.hasClass('active')) {
      $this.removeClass('active');
      $('.design').show(); // show all again
    } else {
      $('.shape').removeClass('active');
      $this.addClass('active');

      // filter designs
      $('.design').each(function () {
        const shape = $(this).data('shape');
        if (shape && shape.toLowerCase() === selectedShape.toLowerCase()) {
          $(this).show();
        } else {
          $(this).hide();
        }
      });
    }

    refreshFlickityIn(offcanvasEl);
  });
}
function getExtra(targetId){
  
  let matchedIndex = -1;
  console.log($('.design-card').length);

const extraIndex = ()=>{
  $('.design-card').each(function(index) {
    if ($(this).data('id') == targetId) {
      console.log("id is",$(this).data('id'));
      matchedIndex = index;
      return false;
    }
  });
}
extraIndex();
console.log("matched index",`${matchedIndex} of ${targetId}`);

if (matchedIndex > totalSlots){
  return true;
}
else{
  return false;
}

}

// function collectDesigns() {
//   const designs = [];

//   $('.card-design').each(function () {
//     const $el = $(this);
//     const quantity = parseInt($el.data('quantity')) || 0;
    
//     // console.log("design", $el);
//     if( __bundle==="basic" ){
//       free_slot = {base: 1, free: 1};
//     }
//     else if( __bundle==="standard" ){
//       free_slot = {base: 2, free: 2};
//     }
//     else if( __bundle==="premium" ){
//       free_slot = {base: 4, free: 4};
//     }
//     const totalSlots = free_slot.base + free_slot.free;
//     if ($el.data("selected") == true) {
//       designs.push({
//         id: $el.data('id'),
//         image: $el.data('image'),
//         name: $el.data('name'),
//         extra: designs.length > (totalSlots - 1),
//         indexp: designs.length,
//         quantity: quantity
//       });
//     }
//   });
//   console.log("design array",designs);
//   return designs;
// }

function designRender() {
    var $container = $('.step2');
    
    $container.empty(); // clear old cards
  
    var free_slot = {base: 1, free: 1};
    $('.bundles_tips').children().addClass('hidden');

    if( __bundle==="basic" ){
      free_slot = {base: 1, free: 1};
    }
    else if( __bundle==="standard" ){
      free_slot = {base: 2, free: 2};
    }
    else if( __bundle==="premium" ){
      free_slot = {base: 3, free: 3};
    }

    $('.bundles_tips').find('[data-type="'+__bundle+'"]').removeClass('hidden');

    // const designs = collectDesigns();

    // const usedSlots = designs.reduce((sum, d) => {
    //   const qty = parseInt(d.quantity, 10) || 0;
    //   return sum + qty;
    // }, 0);
    const usedSlots =  designs.length;

    // Render each design card
    designs.forEach(function (design, index) {
     
      // const qty = parseInt(design.quantity) || 0;

      // // Skip designs with 0 quantity
      // if (qty <= 0) return;
      const loopused = (free_slot.base + free_slot.free) - 1;
      // console.log("used slots", loopused);
      // Repeat the card based on quantity
      // for (let i = 0; i < qty; i++) {
        const { label, class: badgeClass } = getBadgeInfo(index, free_slot);
        let extra = `data-extra="false"`
        if(index > loopused){extra = `data-extra="true"`;}
        
        // console.log("index value", index);
        // console.log("compare", index > loopused);
        // console.log("index extra", extra);
        const card = `
          <div class="design-card col-4 position-relative text-center p-2" 
              data-id="${design.id}" 
              style="height:auto"
              onclick='designsPopupOpen()'
              ${extra}
              data-index=${design.indexp}
              >

            ${label ? `<span class="position-absolute design_card_badge m-1 badge ${badgeClass}">${label}</span>` : ''}
            <button type="button" class="btn-close cs_close position-absolute m-1 btn-remove" aria-label="Remove"></button>
            <div class="design_img">
            <img src="${design.image}" alt="${design.name}" class="img-fluid cs_img" width="124" height="auto">
            </div>
            <small class="d-block card_preview_title mt-2">${design.name}</small>
          </div>
        `;

        $container.append(card);
      // }
    });


    // Calculate total slots (base + free)
    const totalSlots = free_slot.base + free_slot.free;
    let extraSlots = 0;
    const selected_design = document.querySelector('.selected_design');
    const variant = meta.selected_variant || meta.product.variants[0];
    const originalPrice = (variant.price) / 100;
    const discountedAmount = (originalPrice * 20) / 100;
    console.log("discounted amount", discountedAmount);
    const finalDiscountedPrice = parseFloat(originalPrice - discountedAmount).toFixed(2);
    console.log("finalDiscountedPrice", finalDiscountedPrice);
    //ATC buttons
    // get numeric prices
    const price = parseFloat(bundlePrice()) || 0;
    console.log("price",price);
    const compareAt = parseFloat(bundleComparedAtPrice()) || 0;
    console.log("compareAt",compareAt);
    let str = "Add to Cart";
    if(usedSlots < totalSlots) {
          selected_design.textContent = `${usedSlots} of ${totalSlots} selected`;
        }
        else{
          selected_design.textContent = `${totalSlots} of ${totalSlots} selected`;
        }
    
    if( usedSlots>=totalSlots ){
      $("#bundle_atc_container").find(".buy-buttons-container").show();
      $("#bundle_atc_container").find(".choose-design-button-container").hide();

      // If there’s a real discount
      if (compareAt > price && price > 0) {
        console.log("this one");
        str += ` | <del>$${compareAt.toFixed(2)}</del> $${price.toFixed(2)}`;
      }
      else if(usedSlots > totalSlots ){
        extraSlots = usedSlots - totalSlots;
        console.log("run");
        const cumulativeExtraPrice = designs
  .filter(d => d.extra)                    // only extra items
  .reduce((sum, d) => {
    const priceNum = parseInt(d.price.replace(/\$/g, ''), 10); // remove $ and convert
    return sum + (isNaN(priceNum) ? 0 : priceNum);
  }, 0);

console.log("Cumulative price of extra items:", cumulativeExtraPrice);
const cm_discount = (cumulativeExtraPrice * 20) / 100;

        str += `| $${parseFloat(price + (cumulativeExtraPrice - cm_discount)).toFixed(2)}`
      }
      else {
        // No discount, just show price
        console.log("this run");
        str += ` | $${price.toFixed(2)}`;
      }
      
    }
    else{
      $("#bundle_atc_container").find(".buy-buttons-container").hide();
      $("#bundle_atc_container").find(".choose-design-button-container").show();

      //atc_designs_count
      $("#atc_designs_count").html(totalSlots);
    }
    $("#bundle_atc_container").find(".buy-buttons-container").find(".product-form__submit").find("span").html(str);

    

    //console.log(designs.length);
    // Prefill card-nails for remaining slots (up to totalSlots)
    for (let i = usedSlots; i < totalSlots; i++) {
      //console.log(i);
      const { label: nextLabel, class: nextClass } = getBadgeInfo(i, free_slot);
      //console.log(nextLabel);

      // only color the actual free slots (those after base)
      const isFreeSlot = i >= free_slot.base;
      const bgStyle = isFreeSlot ? 'background-color:#f1edea;' : '';

      const addCard = `
        <div class="card-nail col-4 p-2" data-type="Prefill">
          <div class="card-nail-inner border border-secondary d-flex align-items-center justify-content-center position-relative" style="height:200px;cursor:pointer;${bgStyle}">
            ${nextLabel ? `<span class="position-absolute top-0 start-0 m-1 badge ${nextClass}">${nextLabel}</span>` : ''}
            
          </div>
        </div>
      `;

      $container.append(addCard);
    }


    // Only add one more "paid" slot if the user has filled all free ones
    if (usedSlots >= totalSlots) {
      //console.log(designs.length);
      const { label: futureLabel, class: futureClass } = getBadgeInfo(usedSlots, free_slot);

      const addExtraCard = `
        <div class="card-nail col-4 p-2" data-type="free">
          <div class="card-nail-inner border border-secondary d-flex align-items-center justify-content-center position-relative" style="height:200px;cursor:pointer;background-color:#f1edea;">
            ${futureLabel ? `<span class="position-absolute top-0 start-0 m-1 badge ${futureClass}">${futureLabel}</span>` : ''}
            
          </div>
        </div>
      `;
      $container.append(addExtraCard);
    }



    // When any element with class .card-nail is clicked
    $('.card-nail').on('click', function() {
        designsPopupOpen()
    });

    // Remove design handler
    $('.btn-remove').on('click', function(e) {
        e.stopPropagation(); // prevent opening modal accidentally
        var id = $(this).closest('.design-card').data('id');
        var inP = $(this).closest('.design-card').data('index');
        
        removeDesign(id,inP);
    });
}

function getBadgeInfo(index, free_slot) {
    const freeStart = free_slot.base;
    const discountStart = free_slot.base + free_slot.free;
    //console.log(index);

    if (index >= freeStart && index < discountStart) {
      return { label: 'Free', class: 'bg-free' };
    } else if (index >= discountStart) {
      return { label: '-20%', class: 'bg-discount' };
    }
    return { label: '', class: '' }; // no badge
}


// Remove design by ID
function removeDesign(removeId,removeIndex) {
  // const $card = $('.card-design[data-id="' + id + '"]');
  // // let qty = parseInt($card.data('quantity')) || 0;

  // // // decrease quantity but not below 0
  // // qty = Math.max(0, qty - 1);

  // // update DOM and dataset
  // $card.data('quantity', qty);
  // $card.find('.quantity-input').val(qty);
  
    designs = designs.filter(item => {
      return !(item.id === removeId && item.indexp === removeIndex);
    });
  
    
    designs = designs.map((item, i) => ({
      ...item,
      indexp: i
    }));
  

  // trigger bundle update
  window.dispatchEvent(new CustomEvent('__design_remove', { detail: removeId }));
}

function designPick(obj, event) {
  // if the click was on Flickity UI, ignore it
  if (
    event &&
    (event.target.closest('.flickity-page-dots') ||
     event.target.closest('.flickity-prev-next-button'))
  ) {
    console.log("return");
    return; // do nothing
  }
  if( __bundle==="basic" ){
          free_slot = {base: 1, free: 1};
        }
        else if( __bundle==="standard" ){
          free_slot = {base: 2, free: 2};
        }
        else if( __bundle==="premium" ){
          free_slot = {base: 3, free: 3};
        }
        const totalSlots = free_slot.base + free_slot.free;

  let card_obj = $(obj).closest(".card-design");

  $(card_obj).data("quantity", ($(card_obj).data("quantity") || 0) + 1);
  designs.push({
             id: $(card_obj).data('id'),
            image: $(card_obj).data('image'),
            name: $(card_obj).data('name'),
            price: $(card_obj).data('price'),
            extra: designs.length > (totalSlots - 1),
            indexp: designs.length,
          });
          console.log("designs",designs);
// console.log("quantity", $(card_obj.data("quantity")));
  //designRender();
  window.dispatchEvent( new CustomEvent("__bundle_changed", {detail: null}) );
}